export const scrollToStage = (element: HTMLElement | null) => {
    element?.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
    });
};
